import Full from '@rebuild/materials/shared/message_subscription/FullIndex.vue';
import Form from '@rebuild/materials/shared/message_subscription/Form.vue';
import Result from '@rebuild/materials/shared/message_subscription/Result.vue';

export const componentMap = {
	full: Full,
	form: Form,
	result: Result
};
